<div class="loading-state" [ngClass]="{'loading-state--loading': loading}">
    <ng-content></ng-content>
    <app-icon-loading [isSmall]="false" *ngIf="loading"></app-icon-loading>
</div>